import React, { useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "react-feather";
import AppContext from "../../../../context/AppContext";

import "./stylesSiderTab.css";

const SiderTab = ({
  unselectedIcon,
  selectedIcon,
  tabName,
  onPress,
  dropdownOptions = [],
  adminType
}) => {
  const {
    selectedDropdownOption,
    setSelectedDropdownOption,
    setIsDropdownOpen,
    isExpanded,
    setWhichDropdownOpen,
    whichDropdownOpen,
    setIsExpanded,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const handleAvailableOptions = useCallback((options) => {
    const visibleOptions = options.filter(option => option.visible && option.visible.includes(adminType));
    return visibleOptions;
  }, [adminType]);

  const availableOptions = handleAvailableOptions(dropdownOptions);

  useEffect(() => {
    if (availableOptions.length === 0) return;

    const isDropdownOpen = availableOptions.some((option) => option.label === selectedDropdownOption);
    if (isDropdownOpen) {
      setIsDropdownOpen(true);
      setWhichDropdownOpen(prev => [...prev, tabName]);
    }
  }, [selectedDropdownOption, dropdownOptions]);

  const handleTabClicked = () => {
    if (!isExpanded && availableOptions.length > 0) {
      setIsExpanded(true);
    }
    if (availableOptions.length > 0) {
      onPress();
      setIsDropdownOpen((prev) => !prev);
    } else {
      setSelectedDropdownOption(null);
      setIsDropdownOpen(false);
      onPress();
    }
  };

  const handleOptionClick = (option) => {
    setSelectedDropdownOption(option.label);
    navigate(option.navigate);
  };

  return (
    <div className={`sider-tab-container ${whichDropdownOpen.includes(tabName) ? "selected" : ""}`}>
      <button
        className={whichDropdownOpen.includes(tabName) ? "sider-tab-selected" : "sider-tab"}
        onClick={handleTabClicked}
      >
        <div className="tab-content">
          <img
            className="tab-icon"
            src={whichDropdownOpen.includes(tabName) ? selectedIcon : unselectedIcon}
            alt="icon"
          />
          <div className={whichDropdownOpen.includes(tabName) ? "tab-label-selected" : "tab-label-unselected"}>
            {tabName}
          </div>
        </div>

        {isExpanded && availableOptions.length > 0 && (
          <span className="dropdown-toggle">
            {whichDropdownOpen.includes(tabName) ? <ChevronUp /> : <ChevronDown />}
          </span>
        )}
      </button>

      {isExpanded && whichDropdownOpen.includes(tabName) && availableOptions.length > 0 && (
        <div className="dropdown-menu">
          {availableOptions.map((option, index) => (
            <div
              key={index}
              className={`dropdown-option ${selectedDropdownOption === option.label ? "selected" : ""}`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SiderTab;
